import TitleSection from "./TitleSection";
import React from "react";
import Kanban from "../../kanban/Kanban";
import styled from "styled-components";

const KanbanSection = ({toggleHandler}) => {
    return (
        <Container>
            <TitleSection
                toggleHandler={toggleHandler}
                title={"Idéation / brainstorming"}
            />
            <Kanban/>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export default KanbanSection